import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

/**
 * useSharedCampaigns
 *
 * Fetches the list of campaigns the current user has accepted invites to
 * compliance-review. Powers the "Shared with me" tab on HomePage and the
 * downstream reviewer pages.
 *
 * Mirrors the cache shape of `useCampaigns` (user-scoped key, query
 * invalidated on user switch via AuthContext.queryClient.clear()), so the
 * two tabs feel identical and a logout cleans up both.
 */
export function useSharedCampaigns() {
  const { user } = useAuth();
  const queryKey = user?.id ? ['sharedCampaigns', user.id] : ['sharedCampaigns', 'anonymous'];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await api.get('/api/reviews/campaigns');
      return Array.isArray(data) ? data : [];
    },
    enabled: !!user?.id,
    staleTime: 60 * 1000,
    retry: 1,
  });
}
